<script setup lang="ts">
import { useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";

const classes = useCssModule();
</script>

<template>
    <Modal>
        <template #header>
            <div :class="classes.thanksCard">
                <img
                    src="@/public/svg/thanks-for-order.svg"
                    alt="thanks for order icon"
                    width="60px"
                    :class="classes.icon"
                />
                <h2 class="tiw__h2">{{ useTranslate("tiw__thanksForOrder__header") }}</h2>
                <p>
                    {{ useTranslate("tiw__thanksForOrder__emailConfirmation") }}
                </p>
            </div>
        </template>

        <div>
            <h2>{{ useTranslate("tiw__thanksForOrder__nextSteps") }}</h2>

            <ul :class="classes.ul">
                <li>
                    {{ useTranslate("tiw__thanksForOrder__nextStepsList__item-1") }}
                </li>
                <li>
                    {{ useTranslate("tiw__thanksForOrder__nextStepsList__item-2") }}
                </li>
                <li>
                    {{ useTranslate("tiw__thanksForOrder__nextStepsList__item-3") }}
                </li>
                <li>
                    {{ useTranslate("tiw__thanksForOrder__nextStepsList__item-4") }}
                </li>
                <li>
                    {{ useTranslate("tiw__thanksForOrder__nextStepsList__item-5") }}
                </li>
            </ul>
        </div>
    </Modal>
</template>

<style module>
.thanksCard {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px;
    background-color: #f5f5f5;
    border-radius: 6px;

    p {
        text-align: center;
        font-size: 12px;
    }
}
.icon {
    margin-bottom: 14px;
}
.ul {
    padding: 0;
    list-style-position: inside;
}
</style>
